export const TDS_DUMMY_DATA = {
  uniqueId: "",
  sectionName: "",
  natureOfPayment: "",
  threshold: 0, 
  code:"",
  deducte: {
    Individual: false,
    Company: false,
    HUF: false,
    Others: false,
  },
  deducteType: "Domestic", // Domestic or Non Domestic -- Only For Company
  residentialStatus: 1, // -- 0: Non- Indian Residential  -- 1: Indian Residential
  tdsRates: [
    {
      tds_date: "",
      tds_rate: 0,
    },
  ],
};
export const TCS_DUMMY_DATA = {
  uniqueId: "",
  sectionName: "",
  natureOfPayment: "",
  code:"",
  threshold: 0,
  deducte: {
    Individual: false,
    HUF: false,
    Others: false,
  },
  tcsRates: [
    {
      tcs_date: "",
      tcs_rate: 0,
    },
  ],
};
export const DEDUCTEE_TYPE_RADIO_OPTIONS = [
  {
    id: "Domestic",
    name: "Domestic",
  },
  {
    id: "Non-Domestic",
    name: "Non-Domestic",
  },
];

export const RESIDENTIAL_TYPE_RADIO_OPTIONS = [
  {
    id: "1",
    name: "Person is resident in India",
  },
  {
    id: "0",
    name: "Person is not resident in India",
  },
];

export const SINGLE_TDS_RATE = {
  tds_date: "",
  tds_rate: 0,
};
export const SINGLE_TCS_RATE = {
  tcs_date: "",
  tcs_rate: 0,
};

// tds_id, section_name, tds_date

export const TDS_MASTER_SORTING_DATA = [
  {
    id: "Newest first",
    _id: "",
    value: "",
    name: "Newest first",
  },
  {
    _id: "tds_id#asc",
    id: "Unique Id - Asc",
    value: "asc",
    name: "Unique Id - Asc",
  },
  {
    _id: "tds_id#desc",
    id: "Unique Id - Desc",
    value: "desc",
    name: "Unique Id - Desc",
  },
  {
    _id: "section_name#asc",
    id: "Section Name - Asc",
    value: "asc",
    name: "Section Name - Asc",
  },
  {
    _id: "section_name#desc",
    id: "Section Name - Desc",
    value: "desc",
    name: "Section Name - Desc",
  },
  {
    _id: "tds_date#asc",
    id: "TDS Date - Asc",
    value: "asc",
    name: "TDS Date - Asc",
  },
  {
    _id: "tds_date#desc",
    id: "TDS Date - Desc",
    value: "desc",
    name: "TDS Date - Desc",
  },
];

export const TCS_MASTER_SORTING_DATA = [
  {
    id: "Newest first",
    _id: "",
    value: "",
    name: "Newest first",
  },
  {
    _id: "tcs_id#asc",
    id: "Unique Id - Asc",
    value: "asc",
    name: "Unique Id - Asc",
  },
  {
    _id: "tcs_id#desc",
    id: "Unique Id - Desc",
    value: "desc",
    name: "Unique Id - Desc",
  },
  {
    _id: "section_name#asc",
    id: "Section Name - Asc",
    value: "asc",
    name: "Section Name - Asc",
  },
  {
    _id: "section_name#desc",
    id: "Section Name - Desc",
    value: "desc",
    name: "Section Name - Desc",
  },
  {
    _id: "tcs_date#asc",
    id: "TCS Date - Asc",
    value: "asc",
    name: "TCS Date - Asc",
  },
  {
    _id: "tcs_date#desc",
    id: "TCS Date - Desc",
    value: "desc",
    name: "TCS Date - Desc",
  },
];
